import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private _scrollTarget = new BehaviorSubject<string | null>(null);
  private _searchTerm = new BehaviorSubject<string | null>(null);
  private _isSearching = new BehaviorSubject<boolean>(false);
  private _activeTopNavItem = new Subject<string>();
  private _openMobileSearch = new Subject<void>();

  public scrollTarget$ = this._scrollTarget.asObservable();
  public searchTerm$ = this._searchTerm.asObservable();
  public isSearching$ = this._isSearching.asObservable();
  public activeTopNavItem$ = this._activeTopNavItem.asObservable();
  public openMobileSearch$ = this._openMobileSearch.asObservable();

  openMobileSearch(): void {
    this._openMobileSearch.next();
  }

  triggerScrollTo(categoria: string | null) {
    if (categoria === null) {
      this._scrollTarget.next(null);
      return;
    }
    this._scrollTarget.next(categoria);
  }

  triggerSearch(searchTerm: string) {
    this._isSearching.next(true);
    this._searchTerm.next(searchTerm);
  }

  clearSearch() {
    this._searchTerm.next(null);
    this._isSearching.next(false);
  }

  setSearchComplete() {
    this._isSearching.next(false);
  }

  setActiveTopNavItem(itemText: string) {
    this._activeTopNavItem.next(itemText);
  }

  resetActiveTopNavItem() {
    this._activeTopNavItem.next('Hub de Soluções');
  }
}
